import React from "react";
import PropTypes from "prop-types";
import ReactInterval from "react-interval";
import "moment/locale/ru";
import moment from "moment";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// import material-ui components
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Input from '@material-ui/core/Input';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import { DateTimePicker } from "@material-ui/pickers";
//import @material-ui/icons
import ChartIcon from "@material-ui/icons/ShowChart";
import BarChartIcon from "@material-ui/icons/Equalizer";
import HorizontalBarChartIcon from "@material-ui/icons/Sort";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import { getMonthFromNum } from "../../utils/misc";
import { getDailySalesChart, getMonthSumSalesChart, getShareSalesChart } from "../../utils/charts";
import { months, years } from "../../variables/general"

import statisticsStyle from "assets/jss/material-dashboard-react/views/statisticsStyle"

import * as actionCreators from "actions/statistics";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        dailySales: state.statistics.dailySales,
        monthSumSales: state.statistics.monthSumSales,
        monthAverageSales: state.statistics.monthAverageSales,
        shareSales: state.statistics.paymentTypesShareInSales,
        machines: state.statistics.machines,
        dailySalesCount: state.statistics.dailySalesCount,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class StatisticsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dailySalesChartData: null,
            dailySalesYear: new Date().getFullYear(),
            dailySalesMonth: new Date().getMonth() + 1,
            dailySalesType: "money",
            monthSumSalesChartData: null,
            monthSumSalesYear: new Date().getFullYear(),
            monthSumSalesType: "money",
            monthAverageSalesChartData: null,
            monthAverageSalesYear: new Date().getFullYear(),
            monthAverageSalesType: "money",
            timeoutEnabled: false,
            shareSalesMachines: [],
            shareSalesChartData: null,
            shareSalesType: "money",
            shareSalesFromTime: moment(new Date().setHours(0,0,0,0)),
            shareSalesToTime: moment(new Date()),
            dailySalesCountChartData: null,
            dailySalesCountYear: new Date().getFullYear(),
            dailySalesCountMonth: new Date().getMonth() + 1,
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        this.setState((prevState) => ({
            ...prevState,
            dailySalesChartData: nextProps.dailySales.isLoaded ? getDailySalesChart(nextProps.dailySales.data, "Средние дневные продажи") : prevState.dailySalesChartData,
            monthSumSalesChartData: nextProps.monthSumSales.isLoaded ? getMonthSumSalesChart(nextProps.monthSumSales.data, "Сумма продаж за месяц") : prevState.monthSumSalesChartData,
            monthAverageSalesChartData: nextProps.monthAverageSales.isLoaded ? getMonthSumSalesChart(nextProps.monthAverageSales.data, "Средние продажи за месяц") : prevState.monthAverageSalesChartData,
            shareSalesChartData: nextProps.shareSales.isLoaded ? getShareSalesChart(nextProps.shareSales.data) : prevState.shareSalesChartData,
            dailySalesCountChartData: nextProps.dailySalesCount.isLoaded ? getDailySalesChart(nextProps.dailySalesCount.data, "Количество продаж за день") : prevState.dailySalesChartData,
        }))
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true,
        });
        this.getData()
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }

    getData(){
        this.props.getStatisticsDailySales(this.props.token, this.state.dailySalesYear, this.state.dailySalesMonth, this.state.dailySalesType);
        this.props.getStatisticsMonthSumSales(this.props.token, this.state.monthSumSalesYear, this.state.monthSumSalesType);
        this.props.getStatisticsMonthAverageSales(this.props.token, this.state.monthAverageSalesYear, this.state.monthAverageSalesType);
        this.props.getStatisticsMachines(this.props.token);
        this.props.getStatisticsPaymentTypesShareInSales(this.props.token, this.state.shareSalesMachines.join(),
            ~~(this.state.shareSalesFromTime.valueOf()/1000), ~~(this.state.shareSalesToTime.valueOf()/1000), this.state.shareSalesType);
        this.props.getStatisticsDailySalesCount(this.props.token, this.state.dailySalesCountYear, this.state.dailySalesCountMonth);
    }

    handleChangeState(type, data){
        this.setState({
            [type]: data
        }, this.getData)
    }

    render(){
        const { classes } = this.props;
        return (
            <Grid container>
                { this.props.dailySales.isLoaded && !!this.state.dailySalesChartData && <GridItem xs={12}>
                    <Card>
                        <CardHeader color="success" icon>
                            <CardIcon color="success">
                                <ChartIcon/>
                            </CardIcon>
                            <p className={classes.cardCategory}/>
                            <h3 className={classes.cardTitle}>{`Средние продажи за ${getMonthFromNum(this.state.dailySalesMonth)}, ${this.state.dailySalesYear}`}</h3>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="orders_order_by">Выбрать месяц:</InputLabel>
                                <Select
                                    value={this.state.dailySalesMonth}
                                    onChange={(e) => this.handleChangeState("dailySalesMonth", e.target.value)}
                                    inputProps={{
                                        name: 'daily_sales_month',
                                        id: 'daily_sales_month',
                                    }}
                                    className={classes.select}

                                >
                                    {months.map((month, key) => (
                                        <MenuItem value={key+1} key={key}>{month}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="orders_order_by">Выбрать год:</InputLabel>
                                <Select
                                    value={this.state.dailySalesYear}
                                    onChange={(e) => this.handleChangeState("dailySalesYear", e.target.value)}
                                    inputProps={{
                                        name: 'daily_sales_year',
                                        id: 'daily_sales_year',
                                    }}
                                    className={classes.select}

                                >
                                    {years.map((year, key) => (
                                        <MenuItem value={year} key={key}>{year}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="orders_order_by">Выбрать тип:</InputLabel>
                                <Select
                                    value={this.state.dailySalesType}
                                    onChange={(e) => this.handleChangeState("dailySalesType", e.target.value)}
                                    inputProps={{
                                        name: 'daily_sales_type',
                                        id: 'daily_sales_type',
                                    }}
                                    className={classes.select}

                                >
                                    <MenuItem value={"money"} >Рубли</MenuItem>
                                    <MenuItem value={"liters"} >Литры</MenuItem>
                                </Select>
                            </FormControl>
                        </CardHeader>
                        <CardBody>
                            <ChartistGraph
                                data={this.state.dailySalesChartData.data}
                                type="Line"
                                options={this.state.dailySalesChartData.options}
                                listener={this.state.dailySalesChartData.animation}
                                className={`${classes.chartContainer} ${classes.successChart} ${classes.mobileWideChart}`}
                            />
                        </CardBody>
                    </Card>
                </GridItem>}
                { this.props.dailySalesCount.isLoaded && !!this.state.dailySalesCountChartData && <GridItem xs={12}>
                    <Card>
                        <CardHeader color="success" icon>
                            <CardIcon color="success">
                                <ChartIcon/>
                            </CardIcon>
                            <p className={classes.cardCategory}/>
                            <h3 className={classes.cardTitle}>{`Количественный срез по продажам за ${getMonthFromNum(this.state.dailySalesMonth)}, ${this.state.dailySalesYear}`}</h3>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="daily_sales_count_month">Выбрать месяц:</InputLabel>
                                <Select
                                    value={this.state.dailySalesCountMonth}
                                    onChange={(e) => this.handleChangeState("dailySalesCountMonth", e.target.value)}
                                    inputProps={{
                                        name: 'daily_sales_count_month',
                                        id: 'daily_sales_count_month',
                                    }}
                                    className={classes.select}

                                >
                                    {months.map((month, key) => (
                                        <MenuItem value={key+1} key={key}>{month}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="daily_sales_count_year">Выбрать год:</InputLabel>
                                <Select
                                    value={this.state.dailySalesCountYear}
                                    onChange={(e) => this.handleChangeState("dailySalesCountYear", e.target.value)}
                                    inputProps={{
                                        name: 'daily_sales_count_year',
                                        id: 'daily_sales_count_year',
                                    }}
                                    className={classes.select}

                                >
                                    {years.map((year, key) => (
                                        <MenuItem value={year} key={key}>{year}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </CardHeader>
                        <CardBody>
                            <ChartistGraph
                                data={this.state.dailySalesCountChartData.data}
                                type="Line"
                                options={this.state.dailySalesCountChartData.options}
                                listener={this.state.dailySalesCountChartData.animation}
                                className={`${classes.chartContainer} ${classes.successChart} ${classes.mobileWideChart}`}
                            />
                        </CardBody>
                    </Card>
                </GridItem>}
                { this.props.monthSumSales.isLoaded && !!this.state.monthSumSalesChartData && <GridItem xs={12} s={6} md={6}>
                    <Card>
                        <CardHeader color="warning" icon>
                            <CardIcon color="warning">
                                <BarChartIcon/>
                            </CardIcon>
                            <p className={classes.cardCategory}/>
                            <h3 className={classes.cardTitle}>{`Сумма продаж за ${this.state.monthSumSalesYear} год`}</h3>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="month_sum_sales_year">Выбрать год:</InputLabel>
                                <Select
                                    value={this.state.monthSumSalesYear}
                                    onChange={(e) => this.handleChangeState("monthSumSalesYear", e.target.value)}
                                    inputProps={{
                                        name: 'month_sum_sales_year',
                                        id: 'month_sum_sales_year',
                                    }}
                                    className={classes.select}

                                >
                                    {years.map((year, key) => (
                                        <MenuItem value={year} key={key}>{year}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="month_sum_sales_type">Выбрать тип:</InputLabel>
                                <Select
                                    value={this.state.monthSumSalesType}
                                    onChange={(e) => this.handleChangeState("monthSumSalesType", e.target.value)}
                                    inputProps={{
                                        name: 'month_sum_sales_type',
                                        id: 'month_sum_sales_type',
                                    }}
                                    className={classes.select}

                                >
                                    <MenuItem value={"money"} >Рубли</MenuItem>
                                    <MenuItem value={"liters"} >Литры</MenuItem>
                                </Select>
                            </FormControl>
                        </CardHeader>
                        <CardBody>
                            <ChartistGraph
                                data={this.state.monthSumSalesChartData.data}
                                type="Bar"
                                options={this.state.monthSumSalesChartData.options}
                                listener={this.state.monthSumSalesChartData.animation}
                                className={`${classes.chartContainer} ${classes.warningChart}`}
                            />
                        </CardBody>
                    </Card>
                </GridItem>}
                { this.props.monthAverageSales.isLoaded && !!this.state.monthAverageSalesChartData && <GridItem xs={12} s={6} md={6}>
                    <Card>
                        <CardHeader color="warning" icon>
                            <CardIcon color="warning">
                                <BarChartIcon/>
                            </CardIcon>
                            <p className={classes.cardCategory}/>
                            <h3 className={classes.cardTitle}>{`Средние продажи за сутки за ${this.state.monthAverageSalesYear} год`}</h3>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="month_avg_sales_year">Выбрать год:</InputLabel>
                                <Select
                                    value={this.state.monthAverageSalesYear}
                                    onChange={(e) => this.handleChangeState("monthAverageSalesYear", e.target.value)}
                                    inputProps={{
                                        name: 'month_avg_sales_year',
                                        id: 'month_avg_sales_year',
                                    }}
                                    className={classes.select}

                                >
                                    {years.map((year, key) => (
                                        <MenuItem value={year} key={key}>{year}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="month_avg_sales_type">Выбрать тип:</InputLabel>
                                <Select
                                    value={this.state.monthAverageSalesType}
                                    onChange={(e) => this.handleChangeState("monthAverageSalesType", e.target.value)}
                                    inputProps={{
                                        name: 'month_avg_sales_type',
                                        id: 'month_avg_sales_type',
                                    }}
                                    className={classes.select}

                                >
                                    <MenuItem value={"money"} >Рубли</MenuItem>
                                    <MenuItem value={"liters"} >Литры</MenuItem>
                                </Select>
                            </FormControl>
                        </CardHeader>
                        <CardBody>
                            <ChartistGraph
                                data={this.state.monthAverageSalesChartData.data}
                                type="Bar"
                                options={this.state.monthAverageSalesChartData.options}
                                listener={this.state.monthAverageSalesChartData.animation}
                                className={`${classes.chartContainer} ${classes.warningChart}`}
                            />
                        </CardBody>
                    </Card>
                </GridItem>}
                { this.props.shareSales.isLoaded && this.props.machines.isLoaded && !!this.state.shareSalesChartData && <GridItem xs={12}>
                    <Card>
                        <CardHeader color="success" icon>
                            <CardIcon color="success">
                                <HorizontalBarChartIcon/>
                            </CardIcon>
                            <p className={classes.cardCategory}/>
                            <h3 className={classes.cardTitle}>Продажи по типам платежей</h3>
                            <DateTimePicker value={this.state.shareSalesFromTime} onChange={(date) => this.handleChangeState("shareSalesFromTime", date)}
                                            ampm={false} invalidDateMessage="Неверный формат даты" label="От" className={classes.dateTime}
                                            okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                            />
                            <DateTimePicker value={this.state.shareSalesToTime} onChange={(date) => this.handleChangeState("shareSalesToTime", date)}
                                            ampm={false} invalidDateMessage="Неверный формат даты" label="До" className={classes.dateTime}
                                            okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                            />
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="select-share-sales-machines">Автоматы</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.shareSalesMachines}
                                    onChange={(e) => this.handleChangeState("shareSalesMachines",e.target.value)}
                                    input={<Input id="select-share-sales-machines" />}
                                    renderValue={selected => selected.join(', ')}
                                >
                                    {this.props.machines.data.map(machine => (
                                        <MenuItem key={machine.id} value={machine.id}>
                                            <Checkbox checked={this.state.shareSalesMachines.indexOf(machine.id) > -1} />
                                            <ListItemText primary={`${machine.id}, ${machine.address}`} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="share_sales_type">Выбрать тип:</InputLabel>
                                <Select
                                    value={this.state.shareSalesType}
                                    onChange={(e) => this.handleChangeState("shareSalesType", e.target.value)}
                                    inputProps={{
                                        name: 'share_sales_type',
                                        id: 'share_sales_type',
                                    }}
                                    className={classes.select}

                                >
                                    <MenuItem value={"money"} >Рубли</MenuItem>
                                    <MenuItem value={"liters"} >Литры</MenuItem>
                                </Select>
                            </FormControl>
                        </CardHeader>
                        <CardBody>
                            <ChartistGraph
                                data={this.state.shareSalesChartData.data}
                                type="Bar"
                                options={this.state.shareSalesChartData.options}
                                listener={this.state.shareSalesChartData.animation}
                                className={`${classes.chartContainer} ${classes.mobileWideChart} ${classes.shareSalesChart}`}
                            />
                        </CardBody>
                    </Card>
                </GridItem> }
                <ReactInterval timeout={15 * 60000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </Grid>
        )
    }
}

StatisticsView.propTypes = {
    getStatisticsDailySales: PropTypes.func,
    getStatisticsMonthSumSales: PropTypes.func,
    getStatisticsMonthAverageSales: PropTypes.func,
    getStatisticsPaymentTypesShareInSales: PropTypes.func,
    getStatisticsMachines: PropTypes.func,
    getStatisticsDailySalesCount: PropTypes.func,
    token: PropTypes.string,
    dailySales: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.arrayOf(PropTypes.number),
        year: PropTypes.number,
        month: PropTypes.number,
    }),
    monthSumSales: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.arrayOf(PropTypes.number),
        year: PropTypes.number,
    }),
    monthAverageSales: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.arrayOf(PropTypes.number),
        year: PropTypes.number,
    }),
    shareSales: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
    }),
    machines: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
    }),
    dailySalesCount: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.arrayOf(PropTypes.number),
        year: PropTypes.number,
        month: PropTypes.number,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(statisticsStyle)(StatisticsView));


// WEBPACK FOOTER //
// ./src/views/Statistics/Statistics.jsx